




























































































































import { Component, Prop } from "vue-property-decorator";
import PaymentForm from "./payment-form";

@Component
class Donation extends PaymentForm {
    @Prop({type: Number}) public minAmount: number;
    public isSelected = true;
    public amount = "";
    public organisation = "";

    /**
     * @see https://github.com/vuejs/vue-class-component/issues/186
     */
    /*public validateForm() {
        super.validateForm();

        if (this.amount === "") {
            this.errorMessage = this.$t("no-amout-error").toString();
        }

        if (parseInt(this.amount) < this.minAmount) {
            this.errorMessage = this.$t("min-value-error").toString();
        }
    }*/
}

export default Donation;



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/scripts/components/payment-donation.vue